/*
 * <size-guide> — drawer de medidas estilo Farm.
 * Lê os dados da tabela de um <script type="application/json"> interno,
 * renderiza os círculos de tamanho e monta a tabela conforme a seleção.
 *
 * Nota: o <x-drawer> do tema move este elemento para o <body> ao abrir
 * (shouldAppendToBody), o que dispara connectedCallback novamente. Por isso
 * a inicialização é idempotente e usamos event delegation (um único listener
 * que sobrevive ao movimento no DOM), evitando listeners duplicados.
 */
class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.selected = new Set();
  }

  connectedCallback() {
    if (this._initialized) return;

    const dataEl = this.querySelector('[data-size-guide-data]');
    if (!dataEl) return;

    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('size-guide: dados inválidos', e);
      return;
    }

    this.tableWrap = this.querySelector('[data-size-guide-table]');
    this.emptyEl = this.querySelector('[data-size-guide-empty]');

    this.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-size-btn]');
      if (btn && this.contains(btn)) this.toggle(btn);
    });

    this._initialized = true;
    this.render();
  }

  toggle(btn) {
    const size = btn.dataset.sizeBtn;
    if (this.selected.has(size)) {
      this.selected.delete(size);
      btn.setAttribute('aria-pressed', 'false');
    } else {
      this.selected.add(size);
      btn.setAttribute('aria-pressed', 'true');
    }
    this.render();
  }

  render() {
    if (!this.tableWrap) return;
    // Mantém a ordem original dos tamanhos, filtrando os selecionados.
    const sizes = this.data.sizes.filter((s) => this.selected.has(s));

    this.tableWrap.innerHTML = '';

    if (sizes.length === 0) {
      if (this.emptyEl) this.emptyEl.hidden = false;
      this.tableWrap.hidden = true;
      return;
    }

    if (this.emptyEl) this.emptyEl.hidden = true;
    this.tableWrap.hidden = false;

    const table = document.createElement('table');
    table.className = 'size-guide__table';

    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    headRow.appendChild(this.cell('th', this.data.headerLabel));
    sizes.forEach((s) => headRow.appendChild(this.cell('th', s)));
    thead.appendChild(headRow);
    table.appendChild(thead);

    const tbody = document.createElement('tbody');
    this.data.rows.forEach((row) => {
      const tr = document.createElement('tr');
      tr.appendChild(this.cell('td', row.label));
      sizes.forEach((s) => tr.appendChild(this.cell('td', row.values[s] || '—')));
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);

    this.tableWrap.appendChild(table);
  }

  cell(tag, text) {
    const el = document.createElement(tag);
    el.textContent = text;
    return el;
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide);
}
